import { useLingui } from "@lingui/react/macro";
import { formatNumber } from "@offstreetparking/design-system/formatters";
import { type PaymentScheduleSummary, payFrequencyMessages } from "@offstreetparking/domain/value/payment-schedule";
import { type SummaryProps, formatDeductionDate } from "../paymentScheduleSummary";
import { SummaryRow } from "./SummaryRow";

export const FirstDeductionRow = ({ overview, locale }: Omit<SummaryProps, "currency">) => {
	const { t } = useLingui();

	if (!overview.firstDeductionDate) {
		return null;
	}

	return (
		<SummaryRow
			label={t`First deduction`}
			value={formatDeductionDate({ date: overview.firstDeductionDate, locale })}
		/>
	);
};

export const DeductionFrequencyRow = ({ overview }: { overview: PaymentScheduleSummary }) => {
	const { i18n, t } = useLingui();

	if (!overview.payFrequency) {
		return null;
	}

	return (
		<SummaryRow
			label={t({
				message: "Deduction frequency",
				comment:
					"Row label in the payroll deduction summary; the value is how often pay periods occur, e.g. Bi-Weekly",
			})}
			value={i18n._(payFrequencyMessages[overview.payFrequency])}
		/>
	);
};

export const NumberOfDeductionsRow = ({ overview, locale }: Omit<SummaryProps, "currency">) => {
	const { i18n, t } = useLingui();
	const deductionCount = formatNumber({ value: overview.deductionCount, locale });
	const label = t`Number of deductions`;

	if (overview.payFrequency) {
		return (
			<SummaryRow
				label={label}
				value={`${deductionCount} (${i18n._(payFrequencyMessages[overview.payFrequency])})`}
			/>
		);
	}

	return <SummaryRow label={label} value={deductionCount} />;
};
